import { CharactersTypes } from '../constants/charactersConstants';

const initialState = {
    characters: [],
    updatedCharId: null,
    selectedCharId: null,
    updatedCharsIds: null,
    updatedTimestamp: null,
    tokens: [],
    sheettemplate: null,
    sheetOpened: false,
    sheetOpenedValues: {},
    sheetOpenedDetail: false,
    sheetOpenedDetailId: '',
    sheetCharId: null,
    sheetShortcuts: [],
    seekForChar: null,
};

const appendOrUpdateToken = (state, tokens) => {
    const newItems = tokens.length ? tokens : [tokens];
    const newIds = tokens.length ? tokens.map(t => t.id) : [];
    const oldItems = [];
    const oldIds = [];
    
    for (let t of state.tokens) {
        if (newIds.indexOf(t.id) < 0 && oldIds.indexOf(t.id) < 0) {
            oldItems.push(t);
            oldIds.push(t.id);
        }
    };

    return [...oldItems, ...newItems];
}

const updateCharacters = (state, newChars) => {
    let inserted = false;
    const chars = [...state.characters].filter(char => {
        return newChars.some(newChar => char.id === newChar.id);
    });

    for (let newChar of newChars) {
        inserted = false;
        for (let charindex in chars) {
            if (chars[charindex].id === newChar.id) {
                inserted = true;
                chars[charindex] = newChar;
            }
        }

        if (!inserted) {
            chars.push(newChar);
        }
    }

    return chars;
}



const deleteToken = (state, token) => {
    let ids = token.length ? token.map(t => t.id) : [token.id];
    return [...state.tokens].filter(t => ids.indexOf(t.id) < 0 );
}

const appendShortcut = (state, sheet) => {
    let newShortcut = [...state.sheetShortcuts];
    let add = true;

    for (let i in newShortcut) {
        if (newShortcut[i].id === sheet.id) {
            newShortcut[i] = sheet;
            add = false;
            break;
        }
    }

    if (add) {
        newShortcut.push(sheet);
    }
    
    return newShortcut;
}

export const charactersReducer = (state = initialState, action) => {
    switch (action.type) {
        case CharactersTypes.SET_CHARACTERS:
            return {
                ...state,
                characters: [...action.chars]
            };
        case CharactersTypes.UPDATE_CHARACTERS:
            return {
                ...state,
                characters: updateCharacters(state, action.chars)
            };
        case CharactersTypes.UPDATE_CHAR:
            return {
                ...state,
                characters: state.characters.map((i) => i.id !== action.id ? i : {...action.char}),
                updatedCharId: action.id,
                updatedTimestamp: action.preventSelfUpdate ? state.updatedTimestamp : (new Date()).getTime() + String(Math.round(Math.random() * 8999) + 1000)
            };
        case CharactersTypes.SELECT_CHAR:
            return {
                ...state,
                selectedCharId: action.charId,
            };
        case CharactersTypes.UPDATE_CHILDREN_CHAR:
            return {
                ...state,
                characters: (() => {
                    let newCharList = [...state.characters].filter(i => i.parentChar !== action.parentId);
                    return [...newCharList, ...action.chars];
                })(),
                updatedCharId: action.parentId,
                updatedTimestamp: action.preventSelfUpdate ? state.updatedTimestamp : (new Date()).getTime() + String(Math.round(Math.random() * 8999) + 1000)
            };
        case CharactersTypes.REMOVE_CHAR:
            return {
                ...state,
                characters: state.characters.filter((i) => i.id !== action.id),
                updatedCharId: action.id,
                updatedTimestamp: action.preventSelfUpdate ? state.updatedTimestamp : (new Date()).getTime() + String(Math.round(Math.random() * 8999) + 1000)
            };
        case CharactersTypes.REMOVE_MULTI_CHAR:
            return {
                ...state,
                characters: state.characters.filter((i) => !action.ids.includes(i.id)),
                updatedCharsIds: action.ids,
                updatedTimestamp: action.preventSelfUpdate ? state.updatedTimestamp : (new Date()).getTime() + String(Math.round(Math.random() * 8999) + 1000)
            };
        case CharactersTypes.UPDATE_TOKEN:
            return {
                ...state,
                tokens: appendOrUpdateToken(state, action.token)
            };
        case CharactersTypes.DELETE_TOKEN:
            return {
                ...state,
                tokens: deleteToken(state, action.token)
            };
        case CharactersTypes.SET_SHEET_TEMPLATE:
            return {
                ...state,
                sheettemplate: action.template
            };
        case CharactersTypes.SET_SHEET_FORM_OPENED:
            return {
                ...state,
                sheetOpened: action.opened,
                sheetCharId: action.charId
            };
        case CharactersTypes.SET_SHEET_VALUES:
            return {
                ...state,
                sheetOpenedValues: {...action.sheet}
            };
        case CharactersTypes.ADD_SHEET_SHORTCUT:
            return {
                ...state,
                sheetShortcuts: appendShortcut(state, action.sheet),
            };
        case CharactersTypes.REMOVE_SHEET_SHORTCUT:
            return {
                ...state,
                sheetShortcuts: state.sheetShortcuts.filter(i => i.id !== action.sheetId)
            };
        case CharactersTypes.SET_OPENED_DETAIL:
            return {
                ...state,
                sheetOpenedDetail: action.opened,
                sheetOpenedDetailId: action.detailId
            };
        case CharactersTypes.SEEK_FOR_TOKEN:
            return {
                ...state,
                seekForChar: {id:action.charId}
            };
        case CharactersTypes.RESET:
            return {
                ...state,
                ...initialState
            };
        default:
            return state;
    }
};